<template>
  <ul class="dropdown-menu">
    <div style="background-color:#009688">REFERRAL</div>
    <template v-for="(item,index) in REFERRAL">
      <li :key="index" @click="chooseItem($event)">
        <a>{{item}}</a>
      </li>
    </template>
    <div style="background-color:#009688">PERSONAL</div>
    <template v-for="(item,index) in PERSONAL">
      <li :key="index + 100" @click="chooseItem($event)">
        <a>{{item}}</a>
      </li>
    </template>
    <div style="background-color:#009688">EMPLOYMENT</div>
    <template v-for="(item,index) in EMPLOYMENT">
      <li :key="index + 200" @click="chooseItem($event)">
        <a>{{item}}</a>
      </li>
    </template>
    <div style="background-color:#009688">BANK</div>
    <template v-for="(item,index) in BANK">
      <li :key="index + 300" @click="chooseItem($event)">
        <a>{{item}}</a>
      </li>
    </template>
  </ul>
</template>

<script>
export default {
  name: 'DropdownMenu',
  props: ['someAddId'],
  data: () => ({
    REFERRAL: [
      'STOREKEY',
      'REFURL',
      'IPADDRESS',
      'TIERKEY',
      'AFFID',
      'SUBID',
      'TEST',
      'CHANNEL'
    ],
    PERSONAL: [
      'REQUESTEDAMOUNT',
      'SSN',
      'DOB',
      'FIRSTNAME',
      'MIDDLEINITAL',
      'LASTNAME',
      'ADDRESS',
      'ADDRESS2',
      'CITY',
      'STATE',
      'ZIP',
      'HOMEPHONE',
      'OTHERPHONE',
      'DLSTATE',
      'DLNUMBER',
      'CONTACTTIME',
      'ADDRESSMONTHS',
      'ADDRESSYEARS',
      'RENTOROWN',
      'ISMILITARY',
      'ISCITIZEN',
      'OTHEROFFERS',
      'EMAIL',
      'AGE'
    ],
    EMPLOYMENT: [
      'INCOMETYPE',
      'PAYTYPE',
      'EMPMONTHS',
      'EMPYEARS',
      'EMPNAME',
      'EMPPHONE',
      'EMPPHONEEXT',
      'HIREDATE',
      'EMPTYPE',
      'JOBTITLE',
      'PAYFREQUENCY',
      'NETMONTHLY',
      'LASTPAYDATE',
      'NEXTPAYDATE',
      'SECONDPAYDATE'
    ],
    BANK: [
      'ACCOUNTHOLDER',
      'BANKNAME',
      'ACCOUNTTYPE',
      'ROUTINGNUMBER',
      'ACCOUNTNUMBER',
      'BANKMONTHS',
      'BANKYEARS',
      'ACTIVECHECKING'
    ],
    addShowFilter: {}
  }),
  methods: {
    chooseItem (e) {
      var addShow = ''
      var addShowP = ''
      if (e.target.children.length === 0) {
        addShow = e.target.innerText
      } else {
        addShow = e.target.children[0].innerText
      }
      if (this.REFERRAL.indexOf(addShow) !== -1) {
        addShowP = 'REFERRAL'
      } else if (this.PERSONAL.indexOf(addShow) !== -1) {
        addShowP = 'PERSONAL'
      } else if (this.EMPLOYMENT.indexOf(addShow) !== -1) {
        addShowP = 'EMPLOYMENT'
      } else if (this.BANK.indexOf(addShow) !== -1) {
        addShowP = 'BANK'
      }
      this.addShowFilter = {
        companyId: this.someAddId.companyId,
        channelId: this.someAddId.channelId,
        portfolioId: this.someAddId.portfolioId,
        type: this.someAddId.type,
        sectionKey: addShowP,
        parameterKey: addShow,
        operator: 'EQ',
        count: 0
      }
      this.$emit('add', this.addShowFilter)
    }
  },
  created () {
  },
  watch: {
    someAddId () {
    }
  }
}
</script>

<style scoped>
.dropdown-menu {
  overflow-y: scroll;
  width: 180px;
  height: 240px;
  border: none;
  box-shadow: 0 5px 30px 0 rgb(0 0 0 / 25%);
  background: #fff;
  color: #000;
  position: absolute;
  top: 24px;
  left: -152px;
  z-index: 1000;
  list-style: none;
  padding-left: 10px;
}
.dropdown-menu div{
  height: 24px;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  margin-top: 10px;
}
.dropdown-menu li{
  background-color: #fff;
  height: 16px;
  font-size: 13px;
  line-height: 12px;
  text-align: left;
  padding: 10px 10px 20px;
}
.dropdown-menu li:hover{
  background-color: #eee;
  height: 16px;
  font-size: 13px;
  line-height: 12px;
  text-align: left;
  padding: 10px 10px 20px;
}
.v-application a {
  color: #000 !important;
}
</style>
